import { Col, Divider, List, Row, Skeleton } from "antd";
import React from "react";

const PlanningDetailSkeleton = () => {

    return (
        <div style={{ padding: 24 }}>
            <span style={{ display: "flex", flexDirection: "column" }}>
                <Skeleton.Input active style={{ marginBottom: 4 }} />
                <Skeleton.Input active style={{ minWidth: 350 }} />
            </span>
            <Divider />
            <Row>
                <Col span={16} style={{ minHeight: "60vh", paddingRight: 8, borderRight: "1px solid #F0F0F0" }}>
                    <Skeleton.Input active style={{ marginBottom: 8 }} />
                    <div style={{ paddingLeft: 8 }}>
                        <Skeleton.Input active block style={{ height: 100, marginBottom: 8 }} />
                    </div>
                    <Skeleton.Input active style={{ marginBottom: 8 }} />
                    <div style={{ paddingLeft: 8 }}>
                        <Skeleton.Input active block style={{ height: 100, marginBottom: 8 }} />
                    </div>

                    <span style={{ display: "flex", flexDirection: "column" }}>
                        <Skeleton.Input active style={{ marginTop: 8, marginBottom: 4 }} />
                        <Skeleton.Input active />
                    </span>
                    <List
                        grid={{ column: 2 }}
                        pagination={{
                            pageSize: 8
                        }}
                        dataSource={
                            Array.from(Array(6).keys())
                        }
                        renderItem={(line) => (
                            <div style={{ margin: 2 }}>
                                <Skeleton.Input active block style={{ height: 75 }} />
                            </div>
                        )}
                    />
                </Col>
                <Col span={8} style={{ paddingLeft: 24 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Skeleton.Input active style={{ marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginBottom: 12 }} />


                        <Skeleton.Input active style={{ marginBottom: 4 }} />

                        <Skeleton.Input active style={{ marginLeft: 4, marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 8, marginBottom: 8 }} />

                        <Skeleton.Input active style={{ marginLeft: 4, marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 8, marginBottom: 8 }} />

                        <Skeleton.Input active style={{ marginLeft: 4, marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 8, marginBottom: 8 }} />

                        <Skeleton.Input active style={{ marginLeft: 4, marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 8, marginBottom: 8 }} />

                        <Skeleton.Input active style={{ marginLeft: 4, marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 8, marginBottom: 12 }} />


                        <Skeleton.Input active style={{ marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 4, marginBottom: 4 }} />
                        <Skeleton.Input active style={{ marginLeft: 8 }} />
                    </div>

                </Col>
            </Row>
        </div>

    );
};

export default PlanningDetailSkeleton;